import { Input } from '@commenda/kakashi';
import { TEquityInfo } from '@commenda/types/src/incorporation/types';
import React from 'react';
import EsopPoolDonutChart from './EsopPoolDonutChart';

type EsopPoolInputProps = {
  equityInfo: TEquityInfo;
  setEquityInfo: React.Dispatch<React.SetStateAction<TEquityInfo>>;
  readOnly?: boolean;
};

const EsopPoolInputKS = ({
  equityInfo,
  setEquityInfo,
  readOnly = false,
}: EsopPoolInputProps) => {
  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-base">ESOP Pool</h3>
      <div className="flex items-center gap-6">
        <div className="w-40 h-40 flex flex-col gap-6 items-center justify-center">
          <EsopPoolDonutChart esopPool={equityInfo?.shareRetained || 0} />
        </div>
        <div className="flex flex-col w-full">
          <div className="flex items-center justify-between gap-2 py-3 pl-3 border-b border-b-stroke-3">
            <div className="flex items-center gap-2 w-full">
              <span className="h-6 w-6 bg-utility-blue-100 rounded-sm" />
              <span className="body-14-medium">Ownership Pool</span>
            </div>
            <div>
              <Input
                className="w-20 text-right"
                readOnly={readOnly}
                disabled
                value={100 - (equityInfo.shareRetained || 0)}
              />
            </div>
          </div>
          <div className="flex items-center justify-between gap-2 py-3 pl-3 border-b border-b-stroke-3">
            <div className="flex items-center gap-2 w-full">
              <span className="h-6 w-6 bg-utility-rose-100 rounded-sm" />
              <span className="body-15-medium">ESOP pool</span>
            </div>
            <div>
              <Input
                className="w-20 hide-arrow text-right"
                type="number"
                max={100}
                min={0}
                step={0.01}
                readOnly={readOnly}
                value={equityInfo.shareRetained || 0}
                defaultValue={equityInfo.shareRetained || 0}
                onChange={(e) => {
                  const isValid =
                    e.target.value.length === 0 ||
                    !Number.isNaN(parseFloat(e.target.value));
                  if (!isValid) return;
                  const currentValue = e.target.value;

                  if (currentValue.includes('.')) {
                    const [intPart, decimalPart] = currentValue.split('.');
                    const formattedIntPart = intPart.replace(/^0+/, '') || '0';
                    e.target.value = `${formattedIntPart}.${decimalPart}`;
                  } else {
                    // For non-decimal numbers, remove leading zeros but allow a single zero
                    e.target.value = currentValue.replace(/^0+/, '') || '0';
                  }

                  if (parseFloat(e.target.value) > 100) return;

                  setEquityInfo((cur) => ({
                    ...cur,
                    shareRetained: parseFloat(e.target.value),
                  }));
                }}
                onWheel={(e) => e.currentTarget.blur()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EsopPoolInputKS;
